import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaterialModule } from '../../module/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-avatar-input-file',
  templateUrl: './avatar-input-file.component.html',
  styleUrl: './avatar-input-file.component.scss',
  standalone: true,
  imports: [TablerIconsModule, MaterialModule, CommonModule]
})
export class AvatarInputFileComponent {
  file: string = '';
  fileUpload: any;
  @Input() ImgPath?: string;
  @Output() newItemEvent = new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
    if (this.ImgPath) {
      this.file = this.ImgPath;
    }
  }

  onFileChange(event: any) {
    const files = event.target.files as FileList;

    if (files.length > 0) {
      const _file = URL.createObjectURL(files[0]);
      this.file = _file;
      this.fileUpload = files;
      this.newItemEvent.emit(this.fileUpload);
      //this.resetInput();
    }
  }

  resetInput() {
    const input = document.getElementById('avatar-input-file') as HTMLInputElement;
    if (input) {
      input.value = "";
    }
  }
}
